import { Button } from 'component/Button'
import { RoundButton } from 'component/Button/RoundButton'
import { Space } from 'component/Space'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { useDemo } from 'page/catalog/store/CatalogContext'
import css from './MoreBottom.module.scss'

export const MoreBottom = observer(() => {
  const demo = useDemo()
  const { stand } = demo
  const { canMore, busy } = demo.form

  const onMore = useLatestCallback(async () => {
    demo.form.more()
    setTimeout(() => window.scrollTo({ top: 1e9, behavior: 'smooth' }), 10)
  })

  if (!canMore) return null

  if (stand) {
    return <Space center>
      <RoundButton primary pad={[0, 24]} disabled={busy} onClick={onMore}>
        {i18n('demo.ShowMore')}
      </RoundButton>
    </Space>
  }

  return <Space center>
    <Button className={css.more} invert disabled={busy} action={onMore}>
      {i18n('demo.ShowMore')}
    </Button>
  </Space>
})
